import Vue from "vue";
import { Store, userStore } from "@/store";

interface DaktelaStore {
  enabled: boolean;
  storageKey: string;
}

const DefaultEnabled = false;

function getStorageKey(): string {
  const userId = userStore.get()?.id;

  return userId ? `DaktelaEnabled:${userId}` : "DaktelaEnabled";
}

function readEnabled(storageKey: string): boolean {
  try {
    return new Store<boolean>(storageKey).get() ?? DefaultEnabled;
  } catch {
    return DefaultEnabled;
  }
}

const initialStorageKey = getStorageKey();

const store = Vue.observable<DaktelaStore>({
  storageKey: initialStorageKey,
  enabled: readEnabled(initialStorageKey),
});

export function isDaktelaEnabled(): boolean {
  return store.enabled;
}

export function syncDaktelaEnabled(): void {
  const storageKey = getStorageKey();
  store.storageKey = storageKey;
  store.enabled = readEnabled(storageKey);
}

export function setDaktelaEnabled(enabled: boolean): void {
  syncDaktelaEnabled();
  store.enabled = enabled;
  new Store<boolean>(store.storageKey).set(enabled);
}

export const daktelaStore = store;
